import magPlus from '../../../pics/icons/magPlus.PNG'
import magMinus from '../../../pics/icons/magMinus.PNG'
import OptionButton from '../OptionButton';
import ToggleButton from './ToggleButton';
import IconExample from './IconExample';

const capTitle = {
    'player': 'Player',
    'ally': 'Ally',
    'monster': 'Enemy',
    'table': 'Table',
}

// Creature type, player, ally, monster
const ButtonMenu = ({currentEncounter, options, creatureType, handlePvOptionChange}) => {
    return (
        <div className='playerOptionsTabPanel'>
            <IconExample currentEncounter={currentEncounter} creatureType={creatureType} iconOptions={options}/>
            <div className='playerViewOptionsChecks editBlockTitle'> 
                <div className='pVChecks pVCheckLeft '> 
                    {parseInt(options.teamSize) < 0 && 
                        <span  style={{fontSize: '10px', color: 'black'}}>
                            ({options.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                        </span>
                    }
                    &nbsp;Shrink&nbsp;<OptionButton imgClassName={'magOptionsSmall'} src={magMinus} message={`Shrink ${capTitle[creatureType]} Icons`} onClickFunction={()=> handlePvOptionChange(creatureType, 'teamSize', -1)}/>
                </div>
                <div className='pVChecks'> 
                    <OptionButton imgClassName={'magOptionsSmall'} src={magPlus} message={`Grow ${capTitle[creatureType]} Icons`} onClickFunction={()=> handlePvOptionChange(creatureType, 'teamSize', 1)}/>&nbsp;Grow
                    &nbsp;{parseInt(options.teamSize) > 0 && 
                        <span  style={{fontSize: '10px', color: 'black'}}>
                            ({options.teamSize}<span style={{fontSize: '8px'}}>x</span>) 
                        </span>
                    }
                </div>
                <ToggleButton side={1} creatureType={creatureType} title={'Hp'} checked={options.showHp} cKey={'showHp'} handlePvOptionChange={handlePvOptionChange}/>
                <ToggleButton side={2} creatureType={creatureType} title={'Hp Bar'} checked={options.showHpBar} cKey={'showHpBar'} handlePvOptionChange={handlePvOptionChange}/>
                <ToggleButton side={1} creatureType={creatureType} title={'Blood'} checked={options.showBlood} cKey={'showBlood'} handlePvOptionChange={handlePvOptionChange}/>
                <ToggleButton side={2} creatureType={creatureType} title={'Show Dead'} checked={options.showDead} cKey={'showDead'} handlePvOptionChange={handlePvOptionChange}/>
                <ToggleButton side={1} creatureType={creatureType} title={'Size'} checked={options.showSize} cKey={'showSize'} handlePvOptionChange={handlePvOptionChange}/>
                
                {creatureType === 'player' 
                    ? <ToggleButton side={2} creatureType={creatureType} title={'Death Saves'} checked={options.deathSaves} cKey={'deathSaves'} handlePvOptionChange={handlePvOptionChange}/>
                    : <ToggleButton side={2} creatureType={creatureType} title={'Real Name'} checked={options.showName} cKey={'showName'} handlePvOptionChange={handlePvOptionChange}/>
                }

                <ToggleButton side={1} creatureType={creatureType} title={'Ac'} checked={options.showAc} cKey={'showAc'} handlePvOptionChange={handlePvOptionChange}/>

            
            </div>
        </div>

    );
}

export default ButtonMenu;